export enum VerifyStatus {
  SUCCESS = 'successful',
  FAIL = 'failed'
}
